/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { PropTypes } from 'prop-types';

import Link from '../../util/link';
import translateObj from '../../util/translateObj';
import { useRoutes } from '../../context/routesContext';
import ComponentIterator from '../../containers/ComponentIterator';

export const DEFAULT_PROPS_ITEMS_PER_ROW = {
  desktop: 3,
  mobile: 2,
  tablet: 3,
};

const GroupedItems = ({ bgColor, color, title, hasViewAll, components, parentComponent, itemsPerRowPerMediaQuery, compId }) => {
  console.log("🚀 ~ GroupedItems ~ hasViewAll:", hasViewAll)
  console.log("🚀 ~ GroupedItems ~ compId:", compId)
  console.log("🚀 ~ GroupedItems ~ components:", components)
  const { language, path } = useRoutes();
  // NOTE: all the logic was copy-pasted from RDL components

  const getLayout = () => {
    const arr = [];
    components.forEach(component => (
      !arr.includes(component.layout) && arr.push(component.layout)
    ));

    if (arr.length === 1) return arr[0];
    return undefined;
  };

  // NOTE: handleMargins disabled by team request

  //  const handleMargins = () => {
  //    if (['StandardArticlePage', 'ListsPostPage', 'RecordsPostPage', 'CoverStoryPostPage'].includes(parentComponent)) {
  //      return 'mt-0 mb-0';
  //    }
  //    if (['NewsPostPage'].includes(parentComponent)) {
  //      return 'mb-0';
  //    }
  //
  //    if (!parentComponent) {
  //      switch (getLayout()) {
  //        case 'curatedList': return 'mb-10 laptop:mb-24';
  //        case 'discos': return 'mt-6 mb-0 mb-10';
  //        default: return 'mt-0 mb-0 tablet:mb-0';
  //       }
  //    }
  //     return '';
  //   };
  //
  const titleMargin = getLayout() === 'discos' ? 'mb-3' : 'mb-8 tablet:mb-10 laptop:mb-26px desktop:mb-29px';

  return (
    <div
      className={`w-full full-width py-8 tablet:py-42px ${parentComponent === 'RecordsPostPage' ? ' laptop:py-14' : 'laptop:py-12'}`}
      style={{ backgroundColor: bgColor }}
    >
      <div className={`flex flex-row justify-between items-center mx-5 tablet:mx-42px laptop:mx-24 ${parentComponent === 'RecordsPostPage' ? 'mb-6 tablet:mb-8 laptop:mb-12' : titleMargin}`}>
        <h2 tabIndex="0" className="text-30 md:text-40 lg:text-56 font-americaRegular tracking-normal leading-tight" style={{ color }}>
          {translateObj(title, language)}
        </h2>
        {/* {
          hasViewAll
          && (
          <Link to={hasViewAll.link} localizationpath={path} className="flex items-center mt-3" aria-label={translateObj(hasViewAll.text, language)}>
            <span
              className="leading-none uppercase font-stratos text-13 tablet:text-13 laptop:text-base desktop:text-base hover:underline mb-2px"
              style={{ color }}
            >
              {translateObj(hasViewAll.text, language)}
            </span>
            <span className="ml-2 font-icon icon-arrow text-10 laptop:text-12" style={{ color }} />
          </Link>
          )
        } */}
      </div>
      {components.map((component) => {
        Object.assign(component, { parentComponent, color, itemsPerRowPerMediaQuery, hasViewAll });
        console.log('component component', component)
        return (
          <div key={`groupedItems-${parentComponent}`} className="mx-5 tablet:mx-42px laptop:mx-24">
            <ComponentIterator components={[component]} />
          </div>
        );
      })}
    </div>
  );
};

GroupedItems.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.shape(),
  hasViewAll: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({}),
  ]),
  components: PropTypes.arrayOf(PropTypes.object),
  parentComponent: PropTypes.string,
  itemsPerRowPerMediaQuery: PropTypes.shape({}),
};

GroupedItems.defaultProps = {
  bgColor: 'transparent',
  color: 'transparent',
  title: null,
  hasViewAll: null,
  components: null,
  parentComponent: null,
  itemsPerRowPerMediaQuery: DEFAULT_PROPS_ITEMS_PER_ROW,
};

export default GroupedItems;
